<template>
    <div class="videos-container">
        <div v-if="videos && user.pro" class="videos flex">
            <template v-for="(video, index) in videos">
                <div
                    :key="index"
                    class="video flex"
                >
                    <base-wistia-loader
                        :video-id="video.wistia_id"
                        :height="68"
                        :width="120"
                        :responsive="false"
                    />
                    <div class="video-title">
                        {{ video.title }}
                    </div>
                </div>
            </template>
        </div>
        <a class="arrow-link" :href="supportLink" target="_blank">Learn more in Knowledge Base <i class="far fa-long-arrow-right" /></a>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        videos: {
            type: Array,
            default: () => [],
        },
        supportLink: {
            type: String,
            default: '#',
        },
    },

    computed: {
        ...mapState(['user']),
    },
};
</script>
